import { lazy } from 'react'

export const PdfRender = lazy(() => import('./PdfRender'))
